import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIStore {
  // State
  sidebarCollapsed: boolean;
  mobileMenuOpen: boolean;
  pageTitle: string | null;

  // Actions
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  setMobileMenuOpen: (open: boolean) => void;
  setPageTitle: (title: string | null) => void;
}

export const useUIStore = create<UIStore>()(
  persist(
    (set) => ({
      // Initial state
      sidebarCollapsed: false,
      mobileMenuOpen: false,
      pageTitle: null,

      // Actions
      toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
      setMobileMenuOpen: (open) => set({ mobileMenuOpen: open }),
      setPageTitle: (title) => set({ pageTitle: title }),
    }),
    {
      name: 'dms-ui-storage',
      partialize: (state) => ({ sidebarCollapsed: state.sidebarCollapsed }),
    }
  )
);

// Selectors
export const selectSidebarCollapsed = (state: UIStore) => state.sidebarCollapsed;
export const selectMobileMenuOpen = (state: UIStore) => state.mobileMenuOpen;
export const selectPageTitle = (state: UIStore) => state.pageTitle;
